import { Component, type ReactNode } from 'react'
import { reloadForUpdate } from '../lib/fresh'
import { Icon } from '../ui/Icon'

/* If a page breaks, say so with a way out, never a blank screen. A missing code file means the site was
   updated: load the new version. */
export class PageGuard extends Component<{ children: ReactNode }, { err: Error | null }> {
  state = { err: null as Error | null }
  static getDerivedStateFromError(err: Error) { return { err } }
  componentDidCatch(err: Error) {
    if (/dynamically imported module|Importing a module script failed|preload CSS|Failed to fetch/i.test(err.message)) reloadForUpdate()
    console.error(err)
  }
  render() {
    if (!this.state.err) return this.props.children
    return (
      <div className="page-broke">
        <div className="card">
          <h1>Something went wrong</h1>
          <p>Reloading usually fixes it.</p>
          <div className="acts">
            <button className="btn btn-primary" onClick={() => location.reload()}><Icon id="i-retry" />Reload</button>
            <button className="btn btn-ghost" onClick={() => { location.href = '/' }}><Icon id="i-home" />Home</button>
          </div>
        </div>
      </div>
    )
  }
}
